<template>
	<div>
		<h2 class="infos">
			Pour n'importe quelle raison, vous pouvez nous joindre par email à
			<a style="color: #3385ff" href="mailto:victor@alduin.com?subject=Support"
				>victor@alduin.com</a
			>
		</h2>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.infos {
	margin-top: 100px;
}
@media only screen and (min-width: 750px) {
	.infos {
		margin-top: 20vh;
		padding: 0 25vw;
	}
}
</style>
